import firebase from 'firebase'
//論理削除とするbool値のキー

//bool 非ログイン(true)か否か
export const getPartnerList = (userid,scope) => {

    firebase.database().ref("partners").on("value", function(PartnerRecord){
      var partners = PartnerRecord.val();
      //console.log(partners)
      firebase.database().ref("api_users_eval").orderByChild("uid").equalTo(userid).once('value').then((snapshot) => {
        let domains = []
        let snap
    
        if(snapshot) {
          snap = typeof snapshot.val === 'function' ? snapshot.val() : snapshot
        } else {
          snap = {}
        }
        var ar = [];
        //連携解除フラグがたっていないオブジェクトのみを抽出
        for(let s in snap){
          if(snap.hasOwnProperty(s)) {
            ar.push(snap[s])
          }
        }
        
        Object.keys(ar).forEach((key) => {
          //console.log(ar[key].domain)
          if (domains.indexOf(ar[key].partner_id) === -1)　{
            domains.push(ar[key].partner_id)
          }
        })
    
        //サービスごとにグループ化
        let groups = {}
    
        let groupingDomains = (domainKey) => {
          groups[domainKey] = []
          Object.keys(ar).forEach((key) => {
            if(ar[key].partner_id === domainKey) {
              groups[domainKey].push(ar[key])
            }
          })
        }
    
        for(var d in domains) {
          if(domains.hasOwnProperty(d)) {
            groupingDomains(domains[d])
          }
        }
    
        let resultArr = []
        let arrCustom = {}
        //グループ毎に最新created_atを抽出し最新をもったオブジェクトをresultとして格納
        Object.keys(groups).forEach((key) => {
          let thisGroupNewestDate = Math.max.apply(null,groups[key].map((g) => {
            //console.log(g.created_at)
            let arr = g.created_at.split(/[- :]/)
            //console.log(arr)
            return Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]))
          }))
    
          for(let i in groups[key]){
            if(groups[key].hasOwnProperty(i)) {
              let arr = groups[key][i].created_at.split(/[- :]/)
              if(Date.parse(new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5])) === thisGroupNewestDate) {
                for(let k in partners) {
                  if(partners[k].uid === groups[key][i].partner_id) {
                    arrCustom = partners[k]
                    arrCustom.comment = groups[key][i].comments
                    arrCustom.point = groups[key][i].evals[0].value
                    // console.log(arrCustom)
                  }
                }
                resultArr.push(arrCustom)
              }
            }
          }
        })
        scope.setState({partnerslist:resultArr})
      });
    });
}


//export default getPartnerList


// WEBPACK FOOTER //
// ./src/functions/getPartnerList.js